export default __webpack_public_path__ + "static/media/logo_MoOngy.233e50f8.svg";